// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:23
import { NotificationMessage_abstract } from './../abstract/SagaSchema/NotificationMessage_abstract';
export class NotificationMessage extends NotificationMessage_abstract {}
